import { createSelector } from 'reselect';
import permissionConstants from 'xm-constants/permissions';
import {
  pruneItemsAndGroups,
  selectFeatureToggleMap,
  selectLoggedInUser,
  selectSubMenuId,
} from './util';

function getUsersNav(loggedInUser, subMenuId, featureToggleMap) {
  const { permissions } = loggedInUser.loggedInUserProfile;

  const enableWebServiceUsers =
    featureToggleMap.ENABLE_LEGACY_WEBSERVICE_USERS !== 'false';

  const navItemGroups = [
    {
      id: 'NAV_USERS',
      items: [
        {
          id: 'NAV_USERS',
          to: 'users',
          permission: permissionConstants.VIEW_MENUITEM_USERS,
          selectorId: 'UsersPlace',
        },
        {
          id: 'NAV_USER_PERFORMANCE',
          to: 'UserPerformance/alerts',
          permission: permissionConstants.VIEW_MENUITEM_USER_PERFORMANCE_REPORT,
          selectorId: 'UserPerformanceReportPlace',
        },
      ],
    },
    enableWebServiceUsers && {
      id: 'NAV_WEB_SERVICE_USERS',
      items: [
        {
          id: 'NAV_FIND_WEB_SERVICE_USERS',
          to: 'CocoonPlace:/xmatters/Persons-Teams/SearchWebServiceUsers/SearchWebServiceUsers.do',
          isActive: () => subMenuId === 'SearchWebServiceUsers', // Cocoon messes with the URL, compare subMenuId instead
          permission:
            permissionConstants.VIEW_MENUITEM_SEARCH_WEB_SERVICE_USERS,
          selectorId: 'SearchWebServiceUsers',
        },
        {
          id: 'NAV_ADD_WEB_SERVICE_USER',
          to: 'CocoonPlace:/xmatters/Persons-Teams/WebServiceUserDetails/WebServiceUserDetails.do',
          permission:
            permissionConstants.VIEW_MENUITEM_SEARCH_WEB_SERVICE_USERS,
          isActive: () => subMenuId === 'WebServiceUserDetails', // Cocoon messes with the URL, compare subMenuId instead
          selectorId: 'WebServiceUserDetails',
        },
      ],
    },
  ];

  return pruneItemsAndGroups(navItemGroups, permissions);
}

export default createSelector(
  [selectLoggedInUser, selectSubMenuId, selectFeatureToggleMap],
  getUsersNav,
);
